"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8809],{

/***/ 78809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CityNearYouSection": function() { return /* binding */ CityNearYouSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);
/* harmony import */ var _GraySection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18737);




var CityNearYouSection = function(param) {
    var title = param.title, description = param.description, listOfMinorCities = param.listOfMinorCities, listOfZips = param.listOfZips;
    if (listOfZips && listOfMinorCities) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GraySection__WEBPACK_IMPORTED_MODULE_3__/* .GraySection */ .g, {
            className: "text-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "description",
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            style: {
                                color: "#818b92"
                            },
                            children: listOfMinorCities.join(", ")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                marginBottom: 30,
                                marginTop: 30
                            }
                        })
                    ]
                })
            })
        });
    }
    return null;
};


/***/ })

}]);